import React from 'react';
import SbEditable from 'storyblok-react';

import { SupportStoryblok } from '../../types/generated-storyblok';
import { DynamicLightboxProvider } from '../Content/DynamicLightbox/DynamicLightbox';
import DynamicComponent from '../DynamicComponent';
import PageSection from '../Layout/PageSection';
import SupportSidebar from '../Support/SupportSidebar';

type Props = {
  blok: SupportStoryblok;
  slug: string;
};

const SupportPage = ({ blok, slug }: Props) => {
  return (
    <main className="my-9 space-y-9 md:my-12 md:space-y-12">
      <PageSection>
        <div className="grid-section">
          <SupportSidebar slug={slug} />
          <div className="col-span-12 space-y-3 md:col-span-8 lg:col-span-6">
            {/* @ts-expect-error require storyblok-react upgrade */}
            <SbEditable key={blok._uid} content={blok}>
              <div>
                <h1 className="text-md font-bold md:text-lg">{blok.title}</h1>
              </div>
            </SbEditable>
            <section>
              <DynamicLightboxProvider>
                {blok.content
                  ? blok.content.map((content) => {
                      return (
                        <DynamicComponent key={content._uid} blok={content} />
                      );
                    })
                  : null}
              </DynamicLightboxProvider>
            </section>
          </div>
        </div>
      </PageSection>
    </main>
  );
};

export default SupportPage;
